import React, { useEffect, useState } from "react";
import { Row, Carousel, Button, Container } from "react-bootstrap";
import "./popup.css";
function PopupActionRequired(props) {
  let imagesArray = props.images;
  const [showMore, setShowMore] = useState(false);
  const [selectedCombination, setSelectedCombination] = useState(0);
  const [packages, setPackages] = useState(0);
  const [vendors, setVendors] = useState(0);
  const [price, setPrice] = useState("");

  // Combination handling
  const [curComurl, setcurComurl] = useState();
  const [isCombPresent, setisCombPresent] = useState();
  const [currcombshow, setcurrcombshow] = useState([]);
  const [currcombsel, setcurrcombsel] = useState([]);
  const [isVerifiedSeller, setisVerifiedSeller] = useState(false);
  const [selValscombcol, setselValscombcol] = useState([null]);
  const [selValscombrow, setselValscombrow] = useState([null]);

  const [resetModal, setResetModal] = useState(false)

  useEffect(() => {
    setResetModal(false)
    setVendors(props?.data?.vendors[0] || []);
    if (props?.data?.attributeList?.length > 0) {
      setSelectedCombination(0);
      if (props?.data?.pkgs && props?.data?.pkgs.length > 0) {
        setPackages(props?.data?.pkgs[1]?.pkgs || []);
      }
    } else {
      setPackages(props.data.pkgs || []);
    }
  }, [props.data]);

  useEffect(()=>{
    if(props?.data?.attributeList?.length < 1){
      setPrice(props?.data?.vendors[0]?.purchase_price)
    }
    else{
      setPrice(undefined)
    }
    if(props.show === "none") {
     setResetModal(true)
    }
    else{
      setResetModal(false)
    }
  },[props.show])

  const changeAttribute = (index) => {
    setSelectedCombination(index);
    setPackages(props.data.pkgs[index + 1].pkgs || []);
  };
  function checkVariant(product, grp, ind, item, acom) {
    console.log(product)
    let arr = [];
    let selectedele = document.getElementById("combind" + grp + "es" + ind);
    let btns = document.getElementsByClassName("shed combgrp" + grp);
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].classList.contains("combactive")) {
        btns[i].classList.remove("combactive");
      }
    }
    selectedele.classList.add("combactive");
    setcurComurl();
    let cmbString = [];

    for (const attr of product.attributeList) {
      console.log(attr)
      if (!attr.selectedValue) {
        return;
      }
      cmbString[product.combination[0].value.indexOf(attr.attribute.name)] =
        attr.selectedValue;
      arr.push(
        cmbString[product.combination[0].value.indexOf(attr.attribute.name)]
      );
    }
    console.log("sdfs")
    setcurrcombshow(arr);
    cmbString = cmbString.join("-");
    let foundCmb = false;
    setisCombPresent(false);
    for (const comb of product.combination) {
      console.log(comb)
      if (comb.url && comb.active) {
        console.log(comb.url)
        let s = comb.url;
        let aop = [];
        aop = s.split("_");
        if (aop[aop.length - 1] === cmbString) {
          foundCmb = true;
          setcurComurl(comb.url);
          setisCombPresent(true);
          product.inActiveVarient = false;
          let isPres = false;
          for (let vurl of product.vendors[0].combination) {

            if (vurl.url === comb.url) {
              console.log("fdsfs",comb.url)
              setcurComurl(vurl.url);

              if (
                vurl.purchase_price !== undefined ||
                vurl.purchase_price !== ""
              ) {
                isPres = true;
                console.log(vurl)
                setPrice(vurl.purchase_price);
                if (props.checkVariant) {
                  props.checkVariant(vurl.url, vurl.purchase_price);
                }
                return;
              } else {
                setPrice("");
                if (props.checkVariant) {
                  props.checkVariant(vurl.url, undefined);
                }
              }
              break;
            } else {
              setPrice("");
            }
          }
          if (!isPres) {
            if (props.checkVariant) {
              props.checkVariant("notfound", undefined);
            }
          }
        }
      }
    }

    if (!foundCmb) {
      setPrice("");
      product.inActiveVarient = true;
      setisCombPresent(false);
      if (props.checkVariant) {
        props.checkVariant("notfound", undefined);
      }
    }
  }

  if(resetModal){
    return null
  }

  return (
    <>
      <div className="popup ex1 action-popup-detail" key={props.id} style={{display:props.show}}>
        <a className="close" onClick={() => {
          setSelectedCombination(null);
          setPrice(null)
          setcurrcombsel([])
          setcurrcombshow([])
          setcurComurl(null)
          props.popupVisibility()
        }}>
          &times;
        </a>
        <div className="oM-c">
          <h2 className="fs-14 theme-col fs-17 theme-col f-700"></h2>

          <Container>
            <Row style={{alignItems:"normal"}}>
              <div className="col-4">
                <Carousel className="contain-Carousel">
                  {imagesArray &&
                    imagesArray.map((item, index) => {
                      if (item.image.startsWith("products")) {
                        return (
                          <Carousel.Item key={index}>
                            <img
                              id={index}
                              className="d-block w-100 img-size"
                              src={
                                props.from === "manualProducts"
                                  ? "https://s3.toolsvilla.com/mob/" +
                                  item.image
                                  : "https://s3.toolsvilla.com/" +
                                  item.image
                              }
                              alt={item.image}
                            />
                          </Carousel.Item>
                        );
                      } else if (item.image.startsWith("mob")) {
                        return (
                          <Carousel.Item key={index}>
                            <img
                              id={index}
                              className="d-block w-100 img-size"
                              src={
                                props.from === "manualProducts"
                                  ? "https://s3.toolsvilla.com/mob/" +
                                  item.image
                                  : "https://s3.toolsvilla.com/" +
                                  item.image
                              }
                              alt={item.image}
                            />
                          </Carousel.Item>
                        );
                      } else {
                        var img = item.image.substr("41");
                        return (
                          <Carousel.Item key={index}>
                            <img
                              id={index}
                              className="d-block w-100 img-size"
                              src={
                                "https://s3.toolsvilla.com/" + img
                              }
                              alt={item.image}
                            />
                          </Carousel.Item>
                        );
                      }
                    })}
                </Carousel>
                {props.data.videos[0] && 
                  <div className="video">
                    <video
                      controls
                      className=""
                      src={"https://media.toolsvilla.com/" + props.data.videos[0]}
                      alt="Product Img"
                    />
                  </div> 
                }
              </div>
              <div className="col-8">
                <div className="product-name">{props.data.productName}</div>
                <div className="product-category">
                  <span>SKU : </span>
                  {props.data.SKU}
                </div>
                {/* <div className="product-category">
                  <span>Price : </span>
                  <span className="price">
                    &#8377; {price}
                  </span>
                </div> */}
                <div className="product-category">
                  <span>Transfer Price  (Incl {props.data.taxClass}% GST) : </span>
                 
                     <span style={{fontWeight:600}}>    &#8377; {price}
                  </span>
                </div>
               {props?.data?.attributeList?.length > 0 ? <div className="product-category">
                <p className="fs-10 text-danger">(Please select a combination to view transfer price)</p>
                </div>:<></>}
                {props?.data?.attributeList &&
                  props?.data?.attributeList?.length > 0 && (
                    <>
                      {/* <div class="combination-name">
                        {props.data.combination[0].value[0]}
                      </div> */}
                      <ul class="mb-0 pl-0  w-90">
                        {props.data.attributeList.map((item, index) => {
                          return (
                            <>
                              <Row >
                                <div className="col-12">
                                  <p className="fs-14 f-600 px-3 pb-2 mb-0">
                                    {item.attribute.name}
                                  </p>
                                </div>
                              </Row>
                              <ul className="l-n d-flex over-flow pb-2 mb-3">
                                {item.values.map((acom, indexx) => {
                                  if (
                                    selValscombrow[index] === index &&
                                    selValscombcol[index] === indexx
                                  ) {
                                    item.selectedValue = acom;
                                    return (
                                      <>
                                        <li class="mx-1 mb-0">
                                          {" "}
                                          <button
                                            id={"combind" + index + "es" + indexx}
                                            className={"combactive shed combgrp" + index}
                                            onClick={() => {                        
                                              checkVariant(
                                                props.data,
                                                index,
                                                indexx,
                                                item,
                                                acom
                                              );
                                            }}
                                          >
                                            {acom}
                                          </button>
                                        </li>
                                      </>
                                    );
                                  } else {
                                    return (
                                      <>
                                        <li class="mx-1 mb-0">
                                          {" "}
                                          <button
                                            id={"combind" + index + "es" + indexx}
                                            className={"shed combgrp" + index}
                                            onClick={() => {
                                              item.selectedValue = acom;
                                              checkVariant(
                                                props.data,
                                                index,
                                                indexx,
                                                item,
                                                acom
                                              );
                                            }}
                                          >
                                            {acom}
                                          </button>
                                        </li>
                                      </>
                                    );
                                  }
                                })}
                              </ul>
                            </>
                          );
                        })}
                      </ul>
                    </>
                  )}
                {/* {packages && packages.length > 0 && (
                  <>
                    <div className="shiping">
                      <div className="title">Shipping</div>
                      <>
                        <div className="desc">
                          {packages.map((pkg, index) => {
                            return (
                              <div className="row">
                                <div className="col-12">
                                  <span className="bold">
                                    Package {index + 1}
                                  </span>{" "}
                                  ({pkg.productName})
                                </div>
                                <div className="col-6">
                                  <span className="bold">Product Weight :</span>{" "}
                                  {pkg.actualWeight}Kg
                                </div>
                                <div className="col-6">
                                  <span className="bold">
                                    Volumetric Weight :
                                  </span>{" "}
                                  {pkg.vWeight} Kg
                                </div>
                                <div className="col-12">
                                  <span className="bold">
                                    After Packaging :
                                  </span>{" "}
                                  {pkg.weight} Kg
                                </div>
                                <div className="col-12">
                                  <span className="bold">Dimensions :</span>{" "}
                                  {(pkg.packageLength / 30.48).toFixed(2)}L x{(pkg.packageWidth / 30.48).toFixed(2)}B x{" "}
                                  {(pkg.packageHeight / 30.48).toFixed(2)}H ft
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </>
                    </div>
                    <div className="popup-note">
                      <div className="title">Note: </div>
                      <div className="desc">
                        All the shipments are checked at our courier warehouse
                        and if in case the product weight & dimensions are found
                        different than that given by the logistics company
                        Toolsvilla would debit the seller for the difference.We
                        therefore request you to be careful when entering the
                        weight & dimensions. Thank you!
                      </div>
                    </div>
                  </>
                )} */}
                <div className="short-desc mt-2">
                  <div className="fs-13 mt-2 bold">Short Descripion : </div>
                  <div
                    className="desc"
                    dangerouslySetInnerHTML={{
                      __html: props.data.shortDescription,
                    }}
                  />
                  {/* {" "}
                    {props.data.shortDescription || "NA"} */}
                  {/* </div> */}
                </div>
                <div className="long-desc">
                  <div className="fs-13 mt-2 bold">Descripion : </div>

                  <div
                    className="desc"
                    dangerouslySetInnerHTML={{
                      __html: props.data.description,
                    }}
                  />
                  {props?.data?.descriptionNew.map((item, index) => {
                    return <><div class="fs-13 mt-2 bold">{item?.title} : </div><div
                      className="desc fs-13"
                      dangerouslySetInnerHTML={{
                        __html: item.description,
                      }} />
                      {item?.title == 'Specification' && props?.data?.specificationNew && props?.data?.specificationNew.length > 0 &&
                        props?.data?.specificationNew && props?.data?.specificationNew.map((item, index) => {
                          return <><div
                            className="desc fs-14"
                          >
                            <ul className='mb-0'>
                              <li>
                                {item?.type?.name} : {item?.name}{" "}{item?.unit}
                              </li>
                            </ul>
                          </div></>
                        })
                      }
                    </>
                  })}
                  {!(props?.data?.descriptionNew || []).some(obj => obj.title === "Specifications" || obj.title === "Specification") && props?.data?.specificationNew && <>
                    <div>
                      <div class="title fs-14 mb-1 mt-2 bold">Specifications : </div>
                      {props?.data?.specificationNew && props?.specificationNew != "[]" && props?.specificationNew.map((item, index) => {
                        return <><div
                          className="desc fs-14"
                        >
                          <ul className='mb-0'>
                            <li>
                              {item?.type?.name} : {item?.name}{" "}{item?.unit}
                            </li>
                          </ul>
                        </div></>
                      })}
                    </div></>}
                  {/* {" "}
                    {props.data.description}
                  </div> */}
                  {/* <div
                    className="more-details"
                    onClick={() => setShowMore(!showMore)}
                  >
                    {!showMore
                      ? "Show more product details"
                      : "Hide more product details"}{" "}
                    {">"}
                  </div> */}

                </div>
              </div>
              {/* <div className="col-6">
                <h6 className="f-700 fs-16 theme-col">{props.name}</h6>
                {props.SKU ? (
                  <h6 className="fs-14 f-500">SKU : {props.SKU}</h6>
                ) : (
                  <></>
                )}
                <Row>
                  {props.from === "categories" ? (
                    props.price === null ? (
                      <></>
                    ) : (
                      <div className="col-7 fs-13 f-500">
                        Transfer Price to Toolsvilla(incl. GST) :{" "}
                        <i class="fa fa-inr" aria-hidden="true"></i>{" "}
                        {props.price}{" "}
                      </div>
                    )
                  ) : !props.price ||
                    props.price === undefined ||
                    props.price === null ? (
                    <></>
                  ) : (
                    <div className="col-7 fs-13 f-500">
                      Transfer Price to Toolsvilla(incl. GST) :{" "}
                      <i class="fa fa-inr" aria-hidden="true"></i> {props.price}{" "}
                    </div>
                  )}
                </Row>
                <h6 className="text-danger">Product Details</h6>
                <div
                  id="popupDescription"
                  dangerouslySetInnerHTML={{ __html: props.description }}
                ></div>

                <h6>Short description</h6>
                <div
                  id="popupSpecification "
                  dangerouslySetInnerHTML={{ __html: props.sdescription }}
                ></div>
                
              </div> */}
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default PopupActionRequired;
